<template>
  <v-dialog
    v-model="isAdvFilterDialogOpen"
    max-width="900px"
    @click:outside="$emit('update:is-adv-filter-dialog-open',false)"
  >
    <v-card

    >
        <v-card-title>Advanced Filters</v-card-title>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    props: {
        isAdvFilterDialogOpen: {
            type:Boolean,
            required:true
        }
    },
    setup() {
        return {

        }
    }
}
</script>

<style>

.advanced-filter{
    width: 900px
}

</style>